export default __webpack_public_path__ + "f80e08834d43c4b8b24712fa6e0925fc.png";